<!--
 * @Author: wumao
 * @Date: 2021-11-24 11:26:12
 * @LastEditors: wumao
 * @LastEditTime: 2021-12-21 14:30:10
 * @Description: 目录
-->
<template>
  <!-- 目录 -->
  <Page class="catalogue">
    <div class="title">
      <p><span class="c">C</span><span>ONTENTS</span></p>
      <a-divider style="margin:10px" />
      <strong class="text">目录</strong>
    </div>
    <div class="center">
      <div class="left">
        <Step />
        <Step />
        <Step v-if="resultData.suggest.length" />
        <Step v-if="resultData.policyFundingStatistics && resultData.policyFundingStatistics.policyTotal > 0" />
        <Step noLine />
      </div>
      <div class="right">
        <h3><span>一</span> 工商信息</h3>
        <h3><span>二</span> 测评结果</h3>
        <template v-if="resultData.suggest.length">
          <h3 v-if="resultData.result.accord == 1"><span>三</span> 需提升方面及建议方案</h3>
          <h3 v-else><span>三</span> 未达标原因及解决方案</h3>
        </template>

        <h3>
          <span> {{ resultData.suggest.length ? '四' : '三' }} </span> 分析说明
        </h3>
        <template v-if="resultData.policyFundingStatistics && resultData.policyFundingStatistics.policyTotal > 0">
          <h3><span>五</span> 当前企业可获得的其他政策资助统计</h3>
        </template>
      </div>
    </div>
    <div class="mask">
      <div class="cir cir1"></div>
      <div class="cir cir2"></div>
      <div class="cir cir3"></div>
      <div class="cir cir4"></div>
    </div>
  </Page>
</template>

<script>
import Page from './Page.vue'
import Step from './Step.vue'
export default {
  props: {
    resultData: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    Page,
    Step,
  },
}
</script>

<style lang="less" scoped>
.catalogue {
  position: relative;
  .title {
    width: 1.5rem;
    margin-top: 0.2rem;
    margin-left: 0.2rem;
    text-align: center;
    overflow: hidden;
    .c {
      font-size: 0.3rem;
    }
    span {
      height: 0.42rem;
      font-size: 0.22rem;
      font-weight: 400;
      color: #0072f7;
      line-height: 0.22rem;
    }
    .text {
      font-size: 0.4rem;
      font-weight: 600;
      color: #0072f7;
      line-height: 0.4rem;
      letter-spacing: 0.08rem;
    }
  }
  .center {
    width: 6rem;
    margin-top: 1.2rem;
    margin-left: 0.3rem;
    display: flex;
    justify-content: center;
    .right {
      margin-left: 0.2rem;
      margin-top: -0.08rem;
      text-align: center;
      h3 {
        height: 1.34rem;
        font-size: 0.28rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;
        line-height: 0.3rem;
        text-align: left;
        span {
          display: inline-block;
          margin-right: 0.2rem;
        }
      }
    }
  }
  .mask {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 10;
    .cir {
      position: absolute;
      border-radius: 50%;
    }
    .cir1 {
      right: 1rem;
      top: 2.15rem;
      width: 0.2rem;
      height: 0.2rem;
      background: #f3f3f3;
    }
    .cir2 {
      right: -0.45rem;
      top: 3rem;
      width: 0.7rem;
      height: 0.7rem;
      background: #4c9cf9;
      opacity: 0.8;
    }
    .cir3 {
      left: -0.35rem;
      bottom: 1rem;
      width: 0.6rem;
      height: 0.6rem;
      background: #eeeeee;
      opacity: 0.8;
    }
    .cir4 {
      left: 2rem;
      bottom: -0.4rem;
      width: 0.8rem;
      height: 0.8rem;
      background: #e5f0fe;
      opacity: 0.5;
    }
  }
}
</style>
